import React from 'react'

const customStyle= (isCentered) => {
    return isCentered ? { width: "100%", textAlign: "center" } : {}
}

const FormRowCell = ({ width, text, isSelected, cb, centerText }) => {
        let isSelectable = cb
        //used to be column-container
    return <li id="cell-container" style={{ width }} 
                    className={`break-word FontSize16 ${isSelectable ? `clickable ${isSelected ? 'selected' : ""}` : ''}`}
                    onClick={cb}>
                    <p className="ellipsis" id="form-row-cell-text" style={customStyle(centerText)}>{text}</p>
                </li>
}

export default FormRowCell